import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, CircularProgress } from '@material-ui/core';
import { useState } from 'react';
import * as Actions from "../../../store/actions"
import { useSelector, useDispatch } from "react-redux"
const NewNotes = props => {

    const dispatch = useDispatch()

    const [PainLevel, setPainLevel] = useState("")
    const [FunctionalLevel, setFunctionalLevel] = useState("")
    const [OtherNotes, setOtherNotes] = useState("")
    const [IsLoading, setIsLoading] = useState(false)

    const Userdata = useSelector(({ auth }) => auth.UserData);

    const baseURL = useSelector(({ utils }) => utils.baseURL);
    const VerifyData = useSelector(({ auth }) => auth.VerifyData);
    const sypLogSummaryId = useSelector(({ meeting }) => meeting.sypLogSummaryId)
    const PatientID = useSelector(({ meeting }) => meeting.PatientID)
    const PainLevel_REDUCER = useSelector(({ meeting }) => meeting.PainLevel)
    const FunctionalLevell_REDUCER = useSelector(({ meeting }) => meeting.FunctionalLevel)
    const OtherNotes_REDUCER = useSelector(({ meeting }) => meeting.OtherNotes)


    console.log({ PainLevel_REDUCER, FunctionalLevell_REDUCER, OtherNotes_REDUCER })

    useEffect(() => {
        setPainLevel(PainLevel_REDUCER)
        setFunctionalLevel(FunctionalLevell_REDUCER)
        setOtherNotes(OtherNotes_REDUCER)
    }, [])

    async function save() {

        setIsLoading(true)
        await dispatch(Actions.SaveNewNotes(PainLevel, FunctionalLevel, OtherNotes))
        setIsLoading(false)
    }

    return (
        <div style={ { width: "100%", height: "calc(100% - 67px)", padding: "10px", maxHeight: "calc(100% - 67px)" } }>
            <div style={ { width: "100%", height: "100%", background: "#f6fbfe", display: "flex", flexDirection: "column" } }>
                <div style={ { height: "50px", width: "100%", borderBottom: "1px solid #dfe0e1", display: "flex", alignItems: "center" } }>
                    <p style={ { padding: "0", margin: "0", color: "#393938", fontSize: "15px", paddingLeft: "20px", paddingRight: "20px" } }>Pain Level</p>
                </div>
                <div style={ { height: "150px", width: "100%", display: "flex", alignItems: "center", padding: "20px", } }>
                    <textarea
                        value={ PainLevel }
                        onChange={ (e) => setPainLevel(e.target.value) }
                        style={ { width: "100%", height: "100%", border: "1px solid #dfe0e1", outline: "none", fontSize: "15px", background: "#e7f5ff", borderRadius: "4px", padding: "10px" } }
                    />
                </div>
                <div style={ { height: "50px", width: "100%", borderBottom: "1px solid #dfe0e1", display: "flex", alignItems: "center" } }>
                    <p style={ { padding: "0", margin: "0", color: "#393938", fontSize: "15px", paddingLeft: "20px", paddingRight: "20px" } }>Functional Level</p>
                </div>
                <div style={ { height: "150px", width: "100%", display: "flex", alignItems: "center", padding: "20px", } }>
                    <textarea
                        value={ FunctionalLevel }
                        onChange={ (e) => setFunctionalLevel(e.target.value) }
                        style={ { width: "100%", height: "100%", border: "1px solid #dfe0e1", outline: "none", fontSize: "15px", background: "#e7f5ff", borderRadius: "4px", padding: "10px" } }
                    />
                </div>
                <div style={ { height: "50px", width: "100%", borderBottom: "1px solid #dfe0e1", display: "flex", alignItems: "center" } }>
                    <p style={ { padding: "0", margin: "0", color: "#393938", fontSize: "15px", paddingLeft: "20px", paddingRight: "20px" } }>RTM Notes</p>
                </div>
                <div style={ { height: "180px", width: "100%", display: "flex", alignItems: "center", padding: "20px", } }>
                    <textarea
                        value={ OtherNotes }
                        onChange={ (e) => setOtherNotes(e.target.value) }
                        style={ { width: "100%", height: "100%", border: "1px solid #dfe0e1", outline: "none", fontSize: "15px", background: "#e7f5ff", borderRadius: "4px", padding: "10px" } }
                    />
                </div>
                <div style={ { height: "50px", width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-end", padding: "20px", } }>
                    {
                        IsLoading ? (
                            <CircularProgress />
                        ) : (
                            <Button
                                onClick={ () => {
                                    save()
                                } }
                                variant='outlined' style={ { textTransform: "capitalize", color: "#393938" } } color="primary">
                                Save
                            </Button>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

NewNotes.propTypes = {}

export default NewNotes